/*
 * View for a list of content
 */

define([
  "marionette",
  "modules/contentsSplit/contents/contentsList/template/contentsListTemplate.html",
], function (Marionette, ContentsListTemplate) {
  var ContentsListView = {};

  ContentsListView.contentsListLayout = Marionette.Layout.extend({
    template: ContentsListTemplate,
    regions: {
      controls: "#contentsControls",
      list: "#list",
      contentPreview: "#previewStuff",
    },
    triggers: {
      "click .icon-play-circle": "preview:content",
      "click .icon-umbrella": "umbrella:content",
    },
    events: {
      'click [class="icon-umbrella"]': "newContentClick",
    },
    newContentClick: function (e) {
      alert("new content click");
    },
  });

  return ContentsListView;
});
